import { useState, useEffect, useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GET_TOOL_CONFIGS } from "../../queries/toolConfigQueries";

export function useToolConfigs() {
  const [toolConfigsFrontEnd, setToolConfigsFrontEnd] = useState([]);
  const [toolConfigsBackEnd, setToolConfigsBackEnd] = useState({});

  const { data: toolConfigData, loading, error } = useQuery(GET_TOOL_CONFIGS);

  const configDataByViewType = useMemo(() => {
    if (!toolConfigData?.toolConfigs) return {};

    return toolConfigData.toolConfigs.reduce((acc, config) => {
      const filteredConfig = {
        unique_id: config.unique_identifier,
        fullName: config.fullName,
        displayName: config.displayName,
        support: config.support,
        pythonClass: config.pythonClass,
        color: config.color,
      };

      config.viewtypes.forEach(viewType => {
        if (!acc[viewType]) {
          acc[viewType] = [];
        }
        acc[viewType].push(filteredConfig);
      });
      return acc;
    }, {});
  }, [toolConfigData]);

  const toolConfigsFrontEndFormatted = useMemo(() => {
    if (!toolConfigData?.toolConfigs) return [];

    return toolConfigData.toolConfigs.map(config => ({
      name: config.fullName,
      shortName: config.displayName,
      category: config.category,
      key: config.unique_identifier,
      color: config.color,
    }));
  }, [toolConfigData]);

  useEffect(() => {
    if (toolConfigData?.toolConfigs) {
      setToolConfigsFrontEnd(toolConfigsFrontEndFormatted);
      setToolConfigsBackEnd(configDataByViewType);
    }
  }, [toolConfigData, toolConfigsFrontEndFormatted, configDataByViewType]);

  return {
    toolConfigsFrontEnd,
    toolConfigsBackEnd,
    loading,
    error,
  };
}
